import React, {  useState } from "react";
import { Link } from "react-router-dom";

import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import { useFormik } from "formik";
import {  Apitoken, Authtoken } from '../Global';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
const SeasonAdd = () => {
  const [backendErrors, setBackendErrors] = useState([]);
  const [menu, setMenu] = useState(false);
  

  const {
    values,
  
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
  } = useFormik({
    initialValues: {
      name: "",
      start: "",
      end: "",
    },
    onSubmit: (values, actions) => {
      axios
        .post("/settings-seasons/add", values, {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        })
        .then((response) => {
          $("#form-submit").text("Add Term");
          delete backendErrors['error'];
          actions.setSubmitting(false);

          if (response.data.code === 200) {
            //setBackendSuccess(response.data.message);
            toast.success(response.data.message);
            actions.resetForm();
            setTimeout(() => {
              window.location.href = "/seasons";
            }, 3000);
          }  else if (response.data.code === 422) {
              setBackendErrors(response.data.error);
          }
          else if (response.data.code === 401) {
            setBackendErrors(response.data.error);
          }
          else {
             setBackendErrors(response.data.error);
          }
        })
        .catch((error) => {
         console.log(error)
        });
    },
  });

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  // const customFuction = (event) =>{
  //   var index = event.target.selectedIndex;
  //   var optionElement = event.target.childNodes[index];
  //   var key_sybmol =  optionElement.getAttribute('key_sybmol');
  //   console.log(key_sybmol);
  //   setCurrencySymbol(key_sybmol)
   
  // }

const customHandleInput = (event) => {
  const Input_name = event.target.name;
  delete backendErrors[Input_name];
};
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /><ToastContainer />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Seasons</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/seasons">Seasons</Link>
                    </li>
                    <li className="breadcrumb-item active">Add Season</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Season</h4>
                    <form action="#" onSubmit={handleSubmit}>
                     
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label> Name</label>
                            <input
                              type="text"
                              name="name"
                              value={values.name}
                              className= "form-input form-control"
                           
                              onChange={(e) => {
                                handleChange(e);
                                customHandleInput(e);
                              }}
                               onBlur={handleBlur}
                               placeholder="Enter Season Name"
                            />
                           <small>
                              {backendErrors.name && (
                                <span className="form-error mt-1">
                                  {backendErrors.name}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        
                        <div className="col-md-3">
                          <div className="form-group">
                            <label> Start Date</label>
                           
                                <div className="input-group">
                                <input 
                                   type="date"
                                  
                                  name="start"
                                  value={values.start}
                                  onChange={(e) => {
                                    handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={handleBlur}
                                  className="form-control" placeholder="Start Date" />
                              </div>


                           <small>
                              {backendErrors.start && (
                                <span className="form-error mt-1">
                                  {backendErrors.start}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label> End</label>
                             <div className="input-group">
                                  <input 
                                   type="date"
                                  
                                  name="end"
                                  value={values.end}
                                  onChange={(e) => {
                                    handleChange(e);
                                    customHandleInput(e);
                                  }}
                                  onBlur={handleBlur}
                                  className="form-control" placeholder="End Date" />
                                 
                              </div>
                           <small>
                              {backendErrors.end && (
                                <span className="form-error mt-1">
                                  {backendErrors.end}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        
                   
                        
                    
                       
                      </div>
                     
                     
                      <small>
                        {backendErrors.status  && (
                          <span className="form-error mt-1">
                            {backendErrors.status}
                          </span>
                        )}

                   
                          
                            </small>
                      <div className="text-end mt-4">
                        <button
                          type="submit" id="form-submit"
                          className="btn btn-primary"
                          disabled={isSubmitting}
                        >
                          Add Season
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SeasonAdd;
